// import { Outlet } from "react-router-dom";
// import FrontHeader from "../../shared/FrontHeader";
// import { setTitle } from "../../helpers/MetaTag";
// import CompanyCard from "../../components/sections/front/CompanyCard";
// import OrganizationCard from "../../components/sections/front/OrganizationCard";
// import MenuCard from "../../components/sections/front/MenuCard";
// import FooterCard from "../../components/sections/front/FooterCard";
// import { useQuery } from "@tanstack/react-query";
// import { profileDetails } from "../../services/ProfileService";

// const FrontLayout = ({ metaTitle, isSidebar = false }) => {
//   setTitle(metaTitle);
//   const { data, isLoading } = useQuery({
//     queryKey: ["profile-details"],
//     queryFn: profileDetails,
//   });

//   const user = data?.data;
//   const organization = user?.organization;
//   return (
//     <div className="dark:bg-darkBg pt-32 bg-gray-100 md:mt-5">
//       <FrontHeader />

//       <div className="relative w-full max-w-full px-3 md:px-6 lg:px-0 md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-5xl 3xl:max-w-6xl mx-auto pt-3 md:pt-0 pb-7 flex flex-col md:flex-row gap-3 items-start">
//         {isSidebar && (
//           <div className="w-full md:w-[35%] lg:w-[28%] md:sticky md:top-36">
//             <div className="space-y-3">
//               <CompanyCard />
//               <OrganizationCard />
//               <MenuCard organization={organization} loading={isLoading} />
//               <div className="hidden md:block">
//                 <FooterCard />
//               </div>
//             </div>
//           </div>
//         )}

//         <div
//           className={`${isSidebar === true ? "w-full md:w-[65%] lg:w-[72%]" : "w-full"}`}
//         >
//           <Outlet />
//         </div>

//         {isSidebar && (
//           <div className="mt-4 md:hidden">
//             <FooterCard />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FrontLayout;

import { Outlet, useLocation } from "react-router-dom";
import FrontHeader from "../../shared/FrontHeader";
import { setTitle } from "../../helpers/MetaTag";
import CompanyCard from "../../components/sections/front/CompanyCard";
import OrganizationCard from "../../components/sections/front/OrganizationCard";
import MenuCard from "../../components/sections/front/MenuCard";
import FooterCard from "../../components/sections/front/FooterCard";
import { useQuery } from "@tanstack/react-query";
import { profileDetails } from "../../services/ProfileService";

const FrontLayout = ({ metaTitle, isSidebar = false }) => {
  setTitle(metaTitle);

  const location = useLocation();

  // Don't call API for "/" or "/job"
  const shouldFetchProfile = location.pathname !== "/job";
  // location.pathname !== "/" && location.pathname !== "/job";

  const { data, isLoading } = useQuery({
    queryKey: ["profile-details"],
    queryFn: profileDetails,
    enabled: shouldFetchProfile, // 👈 condition here
  });

  const user = data?.data;
  const organization = user?.organization;

  return (
    <div className="bg-gray-100 min-h-screen">
      <FrontHeader />

      <div className="w-full px-3 md:px-6 max-w-full md:md:max-w-[1200px] 3xl:max-w-6xl mx-auto flex flex-col md:flex-row gap-4 items-start mt-4 md:mt-0 "> 
        {isSidebar && (         
          <div className="w-full md:w-[35%] lg:w-[28%] md:sticky md:top-[75px] md:h-[calc(100vh-75px)] md:overflow-y-auto md:pt-3">
            <div className="space-y-3">
              <CompanyCard />
              <OrganizationCard />
              <MenuCard organization={organization} loading={isLoading} />
              <div className="hidden md:block">
                <FooterCard />
              </div>
            </div>
          </div>
        )}

        <div
          className={`${isSidebar ? "w-full md:w-[65%] lg:w-[72%]" : "w-full"} md:pt-5`}
        >
          <Outlet />
        </div>

        {isSidebar && (
          <div className="mt-4 md:hidden">
            <FooterCard />
          </div>
        )}
      </div>
    </div>
  );
};

export default FrontLayout;
